/* Layout files */
import './assets/style/Constants.css';
import './assets/style/App.css';

/* Global imports */
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useState, useEffect }   from 'react';
import { useTranslation } from 'react-i18next';
import ReactGA from "react-ga4";

/* Local imports */
import ExamplePage              from './pages/ExamplePage';
import GeoPxlLanding            from './pages/GeoPxlLanding';
import NewLandingPage           from './pages/newLandingPage';
import RenderMarkdown           from './pages/RenderMarkdown';

import Cookie                   from './components/Cookie'
import Download                 from './components/Download';
import Login, {NoLogin}         from './components/Login';
import Overview                 from './components/Overview';
import PhotomationCore          from './components/PhotomationCore';
import Storage                  from './components/Storage';
import UserCreate, { UserInfo, ResetPassword, RequestResetPassword } from './components/UserInfo';

import { config } from './components/Constants';
import { GA4App, GA4Web } from './components/GA4';

export function getHomeUrl() {
    return "/";
}

export function getAppUrl() {
    return "https://app." + window.location.host;
}


function App() {
    const { i18n,  } = useTranslation(["UserInfo"]);
    const tabletWidth = 1650;
    const phoneWidth = 500;
    const [isTablet, setIsTablet] = useState((window.innerWidth <= tabletWidth) && (window.innerWidth > phoneWidth));
    const [isPhone, setIsPhone]   = useState((window.innerWidth <= phoneWidth));
    const reload = () => window.location.reload();
    const [lang, setLanguage] = useState(Storage.GetLanguage());
    const languageList = ["en", "nl", "hr", "es"];

    const language = {active: lang, set: setLanguage, list: languageList};

    const handleWindowSizeChange = () => {
        setIsPhone((window.innerWidth <= phoneWidth));
        setIsTablet((window.innerWidth <= tabletWidth) && (window.innerWidth > phoneWidth));
    };

    useEffect(() => {
        i18n.changeLanguage(lang);
        Storage.SetLanguage(lang);
    }, [lang, i18n]);

    useEffect(() => {
        var _paq = window._paq = window._paq || [];
        _paq.push(['requireConsent']);
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function() {
            var u="https://analytics.photomation.be/";
            _paq.push(['setTrackerUrl', u+'matomo.php']);
            _paq.push(['setSiteId', '1']);
            var g=document.createElement('script');
            var s=document.getElementsByTagName('script')[0];
            g.async=true; 
            g.src=u+'matomo.js'; 
            s.parentNode.insertBefore(g,s);
        })();

        ReactGA.initialize([
            { trackingId: config.TRACK_ID_WEB }, { trackingId: config.TRACK_ID_APP },
        ]);
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    return (
        <BrowserRouter>
            {
                (window.location.host.split(".")[0] !== "app") ? (
                    <Routes>
                        <Route path="/">
                            <Route element={<GA4Web />}>
                                <Route element={<Cookie />}>
                                    {/*<Route path="tmp"         element={<GeoPxlLanding language={language}/>} />*/}
                                    <Route index path=""         element={<GeoPxlLanding language={language}/>} />
                                    <Route path="landing"         element={<GeoPxlLanding language={language}/>} />
                                    <Route path="example"        element={<ExamplePage language={language}/>} />
                                    <Route path="privacy"        element={<RenderMarkdown language={language} markdownFile={window.location.origin + '/docs/Privacy/'+language.active+'.md'} className="contentPageMd"/> }/>
                                    <Route path="termsofservice" element={<RenderMarkdown language={language} markdownFile={window.location.origin + '/docs/TermsOfService/'+language.active+'.md'} className="contentPageMd"/> }/>
                                </Route>
                            </Route>
                        </Route>
                    </Routes>
                ) : (
                    <Routes>
                        <Route path="/">
                            <Route element={<GA4Web />}>
                                <Route element={<Cookie />}>
                                    <Route path="privacy"        element={<RenderMarkdown language={language} markdownFile={window.location.origin + '/docs/Privacy/'+language.active+'.md'} className="contentPageMd"/> }/>
                                    <Route path="termsofservice" element={<RenderMarkdown language={language} markdownFile={window.location.origin + '/docs/TermsOfService/'+language.active+'.md'} className="contentPageMd"/> }/>
                                    <Route path="disclaimer"     element={<RenderMarkdown language={language} markdownFile={window.location.origin + '/docs/Disclaimer/'+language.active+'.md'} className="contentPageMd"/> }/>
                                </Route>
                            </Route>
                            <Route element={<GA4App />}>
                                <Route element={<Login language={language}/>}>
                                    <Route index path="" element={<PhotomationCore language={language} tablet={isTablet} phone={isPhone}/>} />
                                    <Route path="user"     element={<UserInfo language={language}/>} />
                                    <Route path="download" element={<Download language={language}/>} />
                                    <Route path="overview" element={<Overview language={language}/>} />
                                </Route>
                                <Route element={<NoLogin language={language}/>}>
                                    <Route path="forgot"            element={<RequestResetPassword language={language}/>} />
                                    <Route path="reset/:uid/:token" element={<ResetPassword language={language}/>} />
                                    <Route path="createuser"        element={<UserCreate language={language}/>} />
                                </Route>
                            </Route>
                            <Route path="/Markers.pdf"   onEnter={reload} />
                        </Route>
                    </Routes>
                )
            }
        </BrowserRouter>
    );
}

export default App;
